// CURS - PDP product_banner offer card: Add + Apply (ATC + discount), in-card feedback, no Rebuy cart open
(function () {
  if (window.__noguPdpOfferInit) return;
  window.__noguPdpOfferInit = true;

  var SUPPRESS_KEY = '__noguPdpOfferSuppressSmartCart';
  var FEEDBACK_MS = 4500;
  var feedbackTimers = new WeakMap();

  document.addEventListener(
    'rebuy:smartcart.show',
    function () {
      if (window[SUPPRESS_KEY] && window.Rebuy && window.Rebuy.SmartCart && typeof window.Rebuy.SmartCart.hide === 'function') {
        window.Rebuy.SmartCart.hide();
      }
    },
    true
  );

  function cartRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function fetchCart() {
    return fetch(cartRoot() + 'cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    }).then(function (r) {
      return r.json();
    });
  }

  function normalizeCode(code) {
    return String(code || '').trim();
  }

  function hasDiscountCode(cart, code) {
    var target = normalizeCode(code).toUpperCase();
    if (!target || !cart || !Array.isArray(cart.discount_codes)) return false;
    return cart.discount_codes.some(function (entry) {
      return entry && String(entry.code).toUpperCase() === target;
    });
  }

  function parseOfferQuantities(buyAttr, freeAttr, title) {
    var buy = parseInt(buyAttr, 10);
    var free = parseInt(freeAttr, 10);
    if (!isNaN(buy) && buy > 0 && !isNaN(free) && free > 0) {
      return { buy: buy, free: free };
    }
    if (!title) return null;
    var m = title.match(/BUY\s+(\d+)\s+.*?GET\s+(\d+)\s+FREE/i);
    if (!m) return null;
    return { buy: parseInt(m[1], 10), free: parseInt(m[2], 10) };
  }

  function getCardUi(btn) {
    var card = btn.closest('.pdp-offer-card');
    if (!card) return null;
    return {
      card: card,
      defaultBlock: card.querySelector('.pdp-offer-card__default'),
      status: card.querySelector('.pdp-offer-card__status'),
      btn: btn,
    };
  }

  function clearCardFeedback(ui, enableButton) {
    if (!ui) return;
    var card = ui.card;
    if (feedbackTimers.has(card)) {
      clearTimeout(feedbackTimers.get(card));
      feedbackTimers.delete(card);
    }
    card.classList.remove('pdp-offer-card--feedback', 'pdp-offer-card--feedback-error');
    if (ui.status) {
      ui.status.hidden = true;
      ui.status.textContent = '';
    }
    if (ui.defaultBlock) ui.defaultBlock.hidden = false;
    if (ui.btn) {
      ui.btn.hidden = false;
      if (enableButton) {
        ui.btn.disabled = false;
        ui.btn.classList.remove('is-loading');
      }
    }
  }

  function showCardFeedback(btn, message, tone) {
    var ui = getCardUi(btn);
    if (!ui || !ui.status) return;

    clearCardFeedback(ui, false);
    ui.btn.classList.remove('is-loading');

    if (ui.defaultBlock) ui.defaultBlock.hidden = true;
    ui.status.hidden = false;
    ui.status.textContent = formatStatusMessage(message);
    if (ui.btn) {
      ui.btn.hidden = true;
      ui.btn.classList.remove('is-loading');
    }
    ui.card.classList.add('pdp-offer-card--feedback');
    if (tone === 'error') ui.card.classList.add('pdp-offer-card--feedback-error');

    var timer = window.setTimeout(function () {
      clearCardFeedback(ui, true);
    }, FEEDBACK_MS);
    feedbackTimers.set(ui.card, timer);
  }

  function findProductForm(btn) {
    var form = btn.closest('form[data-js-product-form]');
    if (form) return form;
    return document.querySelector('form[data-js-product-form]');
  }

  function readFormLineItems(form) {
    var idInput = form.querySelector('[name="id"]');
    var qtyInput = form.querySelector('[name="quantity"]');
    var variantId = idInput ? idInput.value : null;
    var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
    var items = [];
    if (variantId) items.push({ id: variantId, quantity: qty });
    var uv = form.querySelector('input[id^="uv-addon-checkbox-"]:checked');
    if (uv) {
      var uvId = uv.getAttribute('data-variant-id');
      if (uvId) items.push({ id: uvId, quantity: 1 });
    }
    return items;
  }

  function isSoldOut(form) {
    var atc = form.querySelector('[data-js-product-button-add-to-cart]');
    if (!atc) return false;
    return atc.disabled || atc.getAttribute('data-button-status') === 'sold-out';
  }

  function addItems(items) {
    var root = cartRoot();
    if (window.theme && window.theme.Cart && typeof window.theme.Cart.addItems === 'function') {
      return window.theme.Cart.addItems(items).then(function (response) {
        if (response && response.ok === false) {
          return response.json().then(function (err) {
            throw new Error(err && err.description ? err.description : 'Could not add to cart');
          });
        }
        if (typeof window.theme.Cart.updateCart === 'function') {
          return window.theme.Cart.updateCart().then(fetchCart);
        }
        return fetchCart();
      });
    }
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items }),
    }).then(function (response) {
      if (!response.ok) {
        return response.json().then(function (err) {
          throw new Error(err && err.description ? err.description : 'Could not add to cart');
        });
      }
      return fetchCart();
    });
  }

  function applyDiscountViaHiddenIframe(code) {
    return new Promise(function (resolve) {
      var root = cartRoot();
      var redirect = window.location.pathname + window.location.search;
      var src = root + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(redirect);
      var iframe = document.createElement('iframe');
      iframe.setAttribute('aria-hidden', 'true');
      iframe.setAttribute('tabindex', '-1');
      iframe.style.cssText = 'position:absolute;width:0;height:0;border:0;clip:rect(0 0 0 0);';
      var done = false;
      function finish() {
        if (done) return;
        done = true;
        if (iframe.parentNode) iframe.parentNode.removeChild(iframe);
        resolve();
      }
      iframe.onload = function () {
        window.setTimeout(finish, 450);
      };
      window.setTimeout(finish, 3500);
      iframe.src = src;
      document.body.appendChild(iframe);
    });
  }

  function postCartDiscount(discountPayload) {
    var root = cartRoot();
    return fetch(root + 'cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: discountPayload }),
    }).then(function (res) {
      return res.json().then(function (cart) {
        if (!res.ok) {
          throw new Error((cart && cart.description) || 'Discount could not be applied');
        }
        return cart;
      });
    });
  }

  function applyDiscountCode(code) {
    var normalized = normalizeCode(code);
    if (!normalized) return fetchCart();

    return fetchCart().then(function (cart) {
      var codes = [];
      if (Array.isArray(cart.discount_codes)) {
        cart.discount_codes.forEach(function (entry) {
          if (!entry || !entry.code) return;
          if (entry.applicable || String(entry.code).toUpperCase() === normalized.toUpperCase()) {
            codes.push(entry.code);
          }
        });
      }
      if (codes.indexOf(normalized) === -1) codes.push(normalized);

      return postCartDiscount(codes.join(',')).then(function (updatedCart) {
        if (hasDiscountCode(updatedCart, normalized)) return updatedCart;
        return applyDiscountViaHiddenIframe(normalized).then(fetchCart);
      });
    });
  }

  function syncRebuySmartCart(cart, code) {
    return new Promise(function (resolve) {
      if (!window.Rebuy || !window.Rebuy.SmartCart) {
        resolve();
        return;
      }

      var sc = window.Rebuy.SmartCart;
      var normalized = normalizeCode(code);

      function runSync() {
        try {
          if (cart && typeof sc.setCart === 'function') {
            sc.setCart(cart);
          }
          if (
            normalized &&
            hasDiscountCode(cart, normalized) &&
            typeof sc.applyDiscount === 'function'
          ) {
            sc.applyDiscount(normalized);
          }
        } catch (err) {
          if (window.console && console.warn) {
            console.warn('[pdp-offer] Rebuy Smart Cart sync failed', err);
          }
        }
      }

      var settled = false;
      function finish() {
        if (settled) return;
        settled = true;
        resolve();
      }

      function runSyncAndFinish() {
        runSync();
        window.setTimeout(finish, 400);
      }

      if (sc.status === 'ready') {
        runSyncAndFinish();
        return;
      }

      document.addEventListener(
        'rebuy:smartcart.ready',
        function () {
          runSyncAndFinish();
        },
        { once: true }
      );
      window.setTimeout(finish, 2500);
    });
  }

  function refreshCartState(cart, discountCode) {
    var next = Promise.resolve(cart);
    if (window.theme && window.theme.Cart) {
      if (cart && typeof window.theme.Cart.setCurrentData === 'function') {
        window.theme.Cart.setCurrentData(cart);
      }
      if (typeof window.theme.Cart.updateData === 'function') {
        next = next.then(function () {
          return window.theme.Cart.updateData();
        });
      }
      if (typeof window.theme.Cart.updateCart === 'function') {
        next = next.then(function () {
          return window.theme.Cart.updateCart();
        });
      }
    }
    return next
      .then(fetchCart)
      .then(function (fresh) {
        return syncRebuySmartCart(fresh, discountCode).then(function () {
          return fresh;
        });
      });
  }

  function formatStatusMessage(template) {
    if (!template) return '';
    return String(template).replace(/\[br\]/gi, '\n');
  }

  function applyMessageTokens(template, cart, qtys) {
    if (!template) return '';
    var out = template;
    if (qtys) {
      var required = qtys.buy + qtys.free;
      var count = cart && typeof cart.item_count === 'number' ? cart.item_count : 0;
      var remaining = Math.max(required - count, 0);
      out = out.replace(/\[remaining\]/gi, String(remaining));
      out = out.replace(/\[buy\]/gi, String(qtys.buy));
      out = out.replace(/\[free\]/gi, String(qtys.free));
      out = out.replace(/\[count\]/gi, String(count));
    }
    return out;
  }

  // CURS - Success copy from product_banner applied_message* (Admin); tokens optional
  function resolveAppliedMessage(btn, cart, qtys, offerTitle) {
    var template = btn.getAttribute('data-applied-message') || '';
    var unlockedTemplate = btn.getAttribute('data-applied-message-unlocked') || '';

    if (qtys && unlockedTemplate) {
      var required = qtys.buy + qtys.free;
      var count = cart && typeof cart.item_count === 'number' ? cart.item_count : 0;
      if (count >= required) template = unlockedTemplate;
    }

    if (template) return applyMessageTokens(template, cart, qtys);

    return formatStatusMessage(
      'DISCOUNT ADDED TO CART — YOU UNLOCKED BUY 3, GET 1 FREE[br]ADD ANY 4 JEWELRY ITEMS - 1 WILL BE FREE IN CART'
    );
  }

  function onApplyClick(event) {
    var btn = event.currentTarget;
    if (btn.disabled || btn.classList.contains('is-loading')) return;

    var card = btn.closest('.pdp-offer-card');
    var ui = getCardUi(btn);
    if (ui) clearCardFeedback(ui, true);

    var code = btn.getAttribute('data-discount-code');
    var offerTitle = btn.getAttribute('data-offer-title') || '';
    var qtys = parseOfferQuantities(
      btn.getAttribute('data-buy-quantity'),
      btn.getAttribute('data-free-quantity'),
      offerTitle
    );

    var form = findProductForm(btn);
    var items = form ? readFormLineItems(form) : [];

    if (form && isSoldOut(form)) {
      showCardFeedback(btn, 'SELECT AN AVAILABLE VARIANT TO ADD TO CART', 'error');
      return;
    }

    if (form && items.length === 0) {
      showCardFeedback(btn, 'SELECT A VARIANT TO ADD TO CART', 'error');
      return;
    }

    btn.disabled = true;
    btn.classList.add('is-loading');
    window[SUPPRESS_KEY] = true;

    var chain = Promise.resolve();

    if (items.length) {
      chain = chain.then(function () {
        return addItems(items);
      });
    } else {
      chain = chain.then(fetchCart);
    }

    chain
      .then(function (cart) {
        if (!code) return cart;
        return applyDiscountCode(code);
      })
      .then(function (cart) {
        return refreshCartState(cart, code);
      })
      .then(function (cart) {
        if (code && !hasDiscountCode(cart, code)) {
          throw new Error('Discount code could not be applied');
        }
        showCardFeedback(btn, resolveAppliedMessage(btn, cart, qtys, offerTitle), 'success');
      })
      .catch(function (err) {
        showCardFeedback(
          btn,
          (err && err.message ? err.message : 'COULD NOT UPDATE CART').toUpperCase(),
          'error'
        );
      })
      .finally(function () {
        if (!card || !card.classList.contains('pdp-offer-card--feedback')) {
          btn.disabled = false;
          btn.classList.remove('is-loading');
        }
        window.setTimeout(function () {
          window[SUPPRESS_KEY] = false;
        }, 800);
      });
  }

  function bind() {
    document.querySelectorAll('[data-pdp-offer-apply]').forEach(function (btn) {
      if (btn.__noguPdpOfferBound) return;
      btn.__noguPdpOfferBound = true;
      btn.addEventListener('click', onApplyClick);
    });
  }

  function init() {
    bind();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
